import { FormEvent } from 'react'

import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { FormBeketPassengersValues } from 'entities/beket/models/form-passengers/model'

import { EMAIL_REGEX, REGEX_EMAIL } from 'shared/constants/regex'
import { Input } from 'shared/ui/input'
import { Paper } from 'shared/ui/paper'
import {
  PhoneInputWhitLabel,
  customValidatePhone,
} from 'shared/ui/phone-input-label'

import s from './styles.module.scss'

export const FormFeedback = () => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext<FormBeketPassengersValues>()

  const onChangeInputEmail = (event: FormEvent<HTMLInputElement>) => {
    return event?.currentTarget?.value?.replace(REGEX_EMAIL, '')
  }

  return (
    <Paper padding={[20, 16]}>
      <p className={clsx(s.title, 'bold-17')}>
        {t('purchase_page.contact_title')}
      </p>

      <div className={s.contactFieldForm}>
        <Controller
          name="email"
          control={control}
          rules={{
            pattern: {
              value: EMAIL_REGEX,
              message: '',
            },
          }}
          render={({ field }) => (
            <Input
              lang={'en'}
              value={field.value}
              error={errors?.email}
              placeholder={t('email')}
              onChange={(event) => field.onChange(onChangeInputEmail(event))}
            />
          )}
        />

        <Controller
          name="phone"
          control={control}
          rules={{
            validate: customValidatePhone,
          }}
          render={({ field }) => (
            <PhoneInputWhitLabel
              error={errors.phone}
              value={field?.value}
              label={t('purchase_page.phone_number')}
              onChange={(value) => field.onChange(value)}
            />
          )}
        />
      </div>

      <span className={clsx(s.subtitle, 'medium-12')}>
        {t('beket.whatsapp')}
      </span>
    </Paper>
  )
}
